import Link$1 from '../../Utils/Link/Link.js';
import { jsx } from 'react/jsx-runtime';

const Link = ({
  ariaLabel,
  nextLink = true,
  href,
  rel = "_self",
  target = "_self",
  testId,
  children,
  className
}) => {
  return nextLink ? /* @__PURE__ */ jsx(Link$1, {
    href,
    passHref: true,
    children: /* @__PURE__ */ jsx("a", {
      target,
      rel,
      "data-test-id": testId,
      "aria-label": ariaLabel,
      className,
      children
    })
  }) : /* @__PURE__ */ jsx("a", {
    href,
    target,
    rel,
    "data-test-id": testId,
    "aria-label": ariaLabel,
    className,
    children
  });
};

export { Link as default };
//# sourceMappingURL=Link.js.map
